module.exports = "<span *ngIf=\"enableDebug\">\r\n  <ng-content></ng-content>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/visbos-core/error-handling/debug-content/debug-content.component.html
// module id = ./src/app/core/visbos-core/error-handling/debug-content/debug-content.component.html
// module chunks = main